module.exports = {
      id: "epaper-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#epaper",
      toString: function () {
        return this.url;
      }
    }